export default {
    autoHideOnMousedown: false,
    themes: {
        'tooltip': {
            // Stops tooltip closing when clicking on the trigger
            hideTriggers: (events) => events,
            delay: {
                show: 100,
                hide: 0,
            },
        },
        'light-tooltip': {
            $extend: 'tooltip',
        },
        'dark-tooltip': {
            $extend: 'tooltip',
        },
    },
};
